import React from 'react'

import CommonStyle from 'common/styles/common.css'

class YbHighlight extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var text = this.props.text;
    var highlight = this.props.highlight;
    var regexp = null;

    if (!Array.isArray(highlight)) {
      highlight = [highlight];
    }

    regexp = `(${highlight.map(word => `(?:${word.replace(/\s/g,'\\s').replace(/\+/g,'\\+')})`).join('|')})`;
    regexp = new RegExp(regexp);
    text = text.toString().split(regexp);

    return (
      <span>
        {text.map((phrase, index) => (index % 2 ? (
          <span key={index} className={CommonStyle.highlightedText}>{phrase}</span>
        ) : (
          <span key={index}>{phrase}</span>
        )))}
      </span>
    );
  }
}

module.exports = YbHighlight;
